import { ComponentChildren, h } from "preact";
import "./container.scss";

interface Props {
    class?: string;
    style?: string | h.JSX.CSSProperties | h.JSX.SignalLike<string | h.JSX.CSSProperties | undefined> | undefined;
    onKeyUp?: (e: KeyboardEvent) => void;
    children?: ComponentChildren;
}

export function Container(props: Props) {
    return (
        <div class={"component-container" + (props.class ? (" " + props.class) : "")} style={props.style} onKeyUp={props.onKeyUp}>
            {
                props.children
            }
        </div>
    );
}
